// ===== Enums =====

import {
    POST_CONTENT_SCOPE,
}                           from '../enums';

// ** IMPORTANT **: Keep in sync with functions/src/index.ts/buildPostScopeKey
const buildPostScopeKey = ({
    postId,
    scope,
    scopeId,
}: {
    postId: string,
    scope: POST_CONTENT_SCOPE,
    scopeId: string,
}): string => (
    scope === POST_CONTENT_SCOPE.root
        ? `${postId}::${POST_CONTENT_SCOPE.root}`
        : `${postId}::${scope}:${scopeId}`
);

export default buildPostScopeKey;
